import React from "react";
import { Home, Landmark, Network } from "lucide-react";

const PILLARS = [
  {
    icon: Home,
    title: "Des quartiers, pas des immeubles",
    body:
      "Écosystèmes de vie complets. Habitat, commerce, école, santé, énergie, mobilité et loisirs — pensés ensemble, dès le premier trait.",
    accent: "Écosystème",
  },
  {
    icon: Landmark,
    title: "Des actifs, pas des ventes",
    body:
      "Un portefeuille conservé plutôt que cédé. Chaque quartier est structuré en SPV dédié, générant des revenus récurrents sur le long terme.",
    accent: "Conservation",
  },
  {
    icon: Network,
    title: "Une plateforme, pas un promoteur",
    body:
      "KIDH orchestre l'écosystème EKIP — Kip Energy, EKIPTECH, KIPAY — pour offrir des synergies qu'un promoteur isolé ne peut égaler.",
    accent: "Synergie",
  },
];

const Philosophy = () => {
  return (
    <section
      id="philosophie"
      data-testid="philosophy-section"
      className="relative bg-[#FAFAF8] py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-16">
        {/* Section label */}
        <div className="flex items-center gap-3 mb-10">
          <span className="kidh-diamond" />
          <span className="font-body text-[0.7rem] uppercase tracking-[0.32em] text-[#636E72]">
            Notre philosophie
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-20 lg:mb-28">
          <h2
            className="lg:col-span-7 font-heading font-black text-[#0C2340] text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tighter"
            data-testid="philosophy-title"
          >
            Un changement
            <br />
            <span className="text-[#E8611A]">de paradigme</span>
            <br />
            pour l'habitat africain.
          </h2>
          <p className="lg:col-span-5 font-body text-[#2D3436] text-base md:text-lg leading-relaxed lg:pb-4">
            KIDH n'est pas un promoteur immobilier classique. Nous opérons une
            transformation profonde du modèle : concevoir, construire, conserver,
            exploiter et valoriser des quartiers intégrés en Afrique de l'Ouest.
          </p>
        </div>

        {/* 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {PILLARS.map((p, idx) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`philosophy-pillar-${idx}`}
                className="group relative reveal border-t border-[#0C2340]/15 pt-8 hover:border-[#E8611A] transition-colors duration-500"
                style={{ transitionDelay: `${idx * 100}ms` }}
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-heading font-black text-[#0C2340]/12 text-6xl md:text-7xl tracking-tighter select-none leading-none">
                    0{idx + 1}
                  </span>
                  <Icon
                    size={28}
                    strokeWidth={1.4}
                    className="text-[#E8611A] group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <span className="font-body text-[0.65rem] uppercase tracking-[0.28em] text-[#E8611A] mb-3 block">
                  {p.accent}
                </span>
                <h3 className="font-heading font-bold text-[#0C2340] text-xl md:text-2xl leading-tight mb-4 tracking-tight">
                  {p.title}
                </h3>
                <p className="font-body text-[#2D3436] text-sm md:text-base leading-relaxed">
                  {p.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
